var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tfa-verify"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Verifikasi Two-Factor Authentication (2FA)")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitOtp($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "otp"
    }
  }, [_vm._v("Masukkan OTP dari aplikasi Google Authenticator")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otp),
      expression: "otp"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "otp",
      "placeholder": "Masukkan OTP",
      "required": "",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.otp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otp = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e()])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Verifikasi\n                ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a01db2f","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Tfaverify.vue
// module id = 411
// module chunks = 0